import { useState, useEffect } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { api } from '../api';
import { styles, colors } from '../components/UI';

export default function ResetPassword() {
  const [params] = useSearchParams();
  // Capture the token once, then scrub it from the address bar: a reset link
  // is a one-hour credential, and left in the URL it sits in browser history
  // and rides the Referer to every asset this page loads (hardening 2026-09-05).
  const [token] = useState(() => params.get('token') || '');
  const nav = useNavigate();
  useEffect(() => {
    if (token && window.location.search.includes('token=')) {
      try { window.history.replaceState(null, '', window.location.pathname); } catch { /* ignore */ }
    }
  }, [token]);
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const tooShort = pw.length > 0 && pw.length < 8;
  const mismatch = pw2.length > 0 && pw !== pw2;
  const canSubmit = pw.length >= 8 && pw === pw2 && !!token;

  const submit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    setError(''); setBusy(true);
    try {
      await api.resetPassword(token, pw);
      setDone(true);
      setTimeout(() => nav('/login'), 1800);
    } catch (err) {
      setError(err.message);
    } finally { setBusy(false); }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: colors.charcoal, padding: 16
    }}>
      <form onSubmit={submit} style={{
        background: '#fff', borderRadius: 10, width: '100%', maxWidth: 400,
        boxShadow: '0 10px 30px rgba(0,0,0,0.2)', overflow: 'hidden'
      }}>
        <img src="/sss-logo.jpg" alt="Select Safety Services" style={{ width: '100%', display: 'block' }} />
        <div style={{ padding: 24, textAlign: 'center', borderBottom: '1px solid #E5E7EB' }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: colors.textMuted, letterSpacing: 1 }}>SET A NEW PASSWORD</div>
        </div>
        <div style={{ padding: 28 }}>
          {!token && (
            <div style={styles.errorBox}>
              No reset token in the URL. Request a new link from the login page.
            </div>
          )}
          {done ? (
            <div style={{ background: '#D1FAE5', color: '#065F46', padding: '12px 14px', borderRadius: 6, fontSize: 14, lineHeight: 1.5 }}>
              ✓ Password updated. Redirecting to sign-in…
            </div>
          ) : (
            <>
              {error && <div style={styles.errorBox}>{error}</div>}
              <div style={{ marginBottom: 14 }}>
                <label style={styles.label}>New password (8+ chars)</label>
                <input
                  type="password"
                  style={styles.input}
                  value={pw}
                  onChange={e => setPw(e.target.value)}
                  autoFocus
                  required
                />
                {tooShort && <div style={{ fontSize: 11, color: '#EF4444', marginTop: 4 }}>At least 8 characters.</div>}
              </div>
              <div style={{ marginBottom: 18 }}>
                <label style={styles.label}>Confirm new password</label>
                <input
                  type="password"
                  style={styles.input}
                  value={pw2}
                  onChange={e => setPw2(e.target.value)}
                  required
                />
                {mismatch && <div style={{ fontSize: 11, color: '#EF4444', marginTop: 4 }}>Passwords don't match.</div>}
              </div>
              <button type="submit" disabled={busy || !canSubmit} style={{ ...styles.btn, width: '100%', padding: '10px', opacity: canSubmit ? 1 : 0.5 }}>
                {busy ? 'Updating…' : 'Set new password'}
              </button>
              <div style={{ marginTop: 14, textAlign: 'center' }}>
                <Link to="/login" style={{ color: colors.orange, textDecoration: 'none', fontWeight: 600, fontSize: 13 }}>
                  ← Back to sign in
                </Link>
              </div>
            </>
          )}
        </div>
      </form>
    </div>
  );
}
